// Their nav already names the matched broker, and the floating headshot sat on top of their mobile CTAs.
const BROKER_IN_NAV_PATHS = new Set(['/application', '/quotes'])

/** Whether a private page gets the floating broker headshot in its bottom-right corner. */
export function showsBrokerWidget(pathname: string): boolean {
  // The internal console is staff working other people's accounts, where "your broker" is meaningless.
  if (pathname.includes('/internal')) return false
  return !BROKER_IN_NAV_PATHS.has(pathname.replace(/\/+$/, ''))
}
